/*
  SunBorn 9/30 — Minicart discount-code visibility + remove controls.

  Bug fixed: a code applied through a discount link (e.g. the QUEEN20 postcard
  QR codes, /discount/<CODE>) shows on the line item, but the drawer's
  "applied code" chip (#sb-discount-active) rendered hidden — the Liquid
  filter `cart.discount_codes | where: 'applicable'` returns nothing on a
  fresh page render — so the drawer showed "Have a discount code?" with no
  way to remove the code.

  This file, on every drawer render (once the shopper shows cart intent or
  the drawer is open):
   1. Reads /cart.js and collects the active codes (cart.discount_codes that
      are applicable, plus any line-level allocations of type discount_code).
   2. Shows the "CODE ✕" chip and hides the input row when a code is active.
   3. Adds a small ✕ to each line-item discount tag that is a code
      (.discounts__discount). Desktop: the ✕ appears on hover/focus.
      Touch devices (no hover): always visible.
  Removing (chip ✕ or tag ✕) clears the code with /cart/update.js
  {discount: ''} and re-renders the drawer in place.
  Loaded sitewide (defer) from snippets/back-to-top.liquid.
*/
(function () {
  if (window.__sbCartDiscount) return;
  window.__sbCartDiscount = true;

  var CSS =
    '#ajaxcart .discounts__discount{display:inline-flex;align-items:center;gap:6px}' +
    '#ajaxcart .sb-disc-x{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;margin-left:2px;padding:0;border:0;border-radius:50%;background:transparent;color:inherit;font-size:15px;line-height:1;cursor:pointer;opacity:0;transition:opacity .15s,background-color .15s}' +
    '#ajaxcart .discounts__discount:hover .sb-disc-x,#ajaxcart .sb-disc-x:focus-visible{opacity:1}' +
    '#ajaxcart .sb-disc-x:hover{background:rgba(0,0,0,.08)}' +
    '@media (hover:none),(pointer:coarse){#ajaxcart .sb-disc-x{opacity:1}}' +
    '#ajaxcart .sb-disc-x.is-loading{opacity:.4;pointer-events:none}';

  var busy = false;
  var timer = null;

  function activeCodes(cart) {
    var codes = [];
    (cart.discount_codes || []).forEach(function (d) {
      if (d && d.code && d.applicable !== false && codes.indexOf(d.code) === -1) codes.push(d.code);
    });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application;
        if (app && app.type === 'discount_code' && app.title && codes.indexOf(app.title) === -1) codes.push(app.title);
      });
    });
    return codes;
  }

  function isCodeTag(li, codes) {
    var txt = (li.textContent || '').trim().toUpperCase();
    for (var i = 0; i < codes.length; i++) {
      if (txt.indexOf(codes[i].toUpperCase()) > -1) return true;
    }
    return false;
  }

  function apply(cart) {
    var codes = activeCodes(cart);
    var chip = document.getElementById('sb-discount-active');
    var chipCode = document.getElementById('sb-discount-active-code');
    var inputRow = document.getElementById('sb-discount-input-row');
    if (chip && inputRow) {
      if (codes.length) {
        if (chipCode && chipCode.textContent !== codes.join(', ')) chipCode.textContent = codes.join(', ');
        if (chip.hidden) chip.hidden = false;
        if (!inputRow.hidden) inputRow.hidden = true;
      } else {
        if (!chip.hidden) chip.hidden = true;
        if (inputRow.hidden) inputRow.hidden = false;
      }
    }
    document.querySelectorAll('#ajaxcart .discounts__discount').forEach(function (li) {
      var has = li.querySelector('.sb-disc-x');
      if (!codes.length || !isCodeTag(li, codes)) {
        if (has) has.remove();
        return;
      }
      if (has) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sb-disc-x';
      btn.setAttribute('aria-label', 'Remove discount code');
      btn.innerHTML = '&times;';
      li.appendChild(btn);
    });
  }

  function sync() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }

  function removeCode(btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        apply(cart);
        var msg = document.getElementById('sb-discount-msg');
        if (msg) msg.hidden = true;
        if (typeof window.sbRefreshDrawer === 'function') return window.sbRefreshDrawer({ noHighlight: true });
      })
      .catch(function (err) { console.error('SunBorn remove discount failed:', err); })
      .finally(function () {
        busy = false;
        if (btn) btn.classList.remove('is-loading');
      });
  }

  /* Line-tag ✕ and the chip ✕ both go through removeCode (capture phase, so
     the older chip handler in sunborn-cart-drawer.js doesn't double-fire). */
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('#ajaxcart .sb-disc-x, #sb-discount-remove');
    if (!x) return;
    e.preventDefault();
    e.stopPropagation();
    removeCode(x);
  }, true);

  function allowed() {
    var shell = document.querySelector('ajax-cart');
    if (shell && shell.classList.contains('active')) return true;
    return !!(window.sbCartIntentFired && window.sbCartIntentFired());
  }

  function schedule() {
    if (!allowed()) return;
    clearTimeout(timer);
    timer = setTimeout(sync, 60);
  }

  function init() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var root = document.getElementById('ajaxcart');
    var shell = document.querySelector('ajax-cart');
    if (!root || !('MutationObserver' in window)) return;

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && (t.closest('.discounts__discount') || t.closest('#sb-discount-active') || t.closest('.sb-ctk'))) continue;
        schedule();
        return;
      }
    }).observe(root, { childList: true, subtree: true });

    if (shell) {
      new MutationObserver(function () {
        if (shell.classList.contains('active')) schedule();
      }).observe(shell, { attributes: true, attributeFilter: ['class'] });
    }
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
